import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';
import ThemeContextProvider from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext'; 
import { BrandProvider } from "./context/BrandContext";
import { I18nProvider } from "./i18n/I18nProvider";

/** Safari/WebKit às vezes emite "Can't find variable: EmptyRanges" em eventos de mídia;
 *  o overlay de runtime do CRA bloqueia a UI — engolir só esse ruído conhecido. */
function isBenignEmptyRangesError(message) {
  return typeof message === "string" && /EmptyRanges/i.test(message);
}

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      if (isBenignEmptyRangesError(event?.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const reason = event?.reason;
      const msg =
        typeof reason === "string"
          ? reason
          : reason?.message != null
            ? String(reason.message)
            : "";
      if (isBenignEmptyRangesError(msg)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // evita refetch duplicado em montagens rápidas (ex.: StrictMode/dev)
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <I18nProvider>
      <ThemeContextProvider>
        <QueryClientProvider client={queryClient}>
          <BrandProvider>
            <App />
          </BrandProvider>
        </QueryClientProvider>
      </ThemeContextProvider>
    </I18nProvider>
  </AuthProvider>
);

reportWebVitals();
